import Vue  from 'vue';
import Vuex from 'vuex';

import User         from './User';
import Palettes     from './Palettes';
import Undo         from "./Undo";
import CodeOutput   from './CodeOutput';
import SignUpPrompt from "./SignUpPrompt";
import PageTracker  from './PageTracker';
import DraftSwatch  from './DraftSwatch';

Vue.use(Vuex);

export default new Vuex.Store({
    modules: {
        User,
        Palettes,
        Undo,
        CodeOutput,
        SignUpPrompt,
        PageTracker,
        DraftSwatch,
    }
});
